import { message } from "antd";
import axios from "axios";
import download from "downloadjs";

// Generate AI Filtered Image
export const applyImageFilter =
    (uploaded_image_object, filter_type) => async (dispatch) => {
        await axios
            .post(`/api/image_filters/apply_image_filter`, {
                uploaded_image: uploaded_image_object,
                filter_type: filter_type,
            })
            .then(async (response) => {
                dispatch({
                    type: "APPLY_IMAGE_FILTER_SUCCESS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Download product image
export const downloadFilteredImage =
    (filtered_image_uuid, format, resolution, size) => async (dispatch) => {
        await axios
            .get(
                `/api/image_filters/download/${filtered_image_uuid}/${format}/${resolution}/${size}`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then(async (response) => {
                await download(
                    response.data,
                    `img.${format}`,
                    `image/${format}`
                );
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch seamless products of a user
export const fetchUserFilteredImages =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(
                `/api/image_filters/user_filtered_images/${key}/${offset}/${limit}`
            )
            .then(async (response) => {
                dispatch({
                    type: "FETCH_USER_FILTERED_IMAGES_SUCCESS",
                    payload: response.data,
                    key: "user_filtered_images" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
